export default "__VITE_ASSET__CH9Q5pps__"